import { render, staticRenderFns } from "./marginmaster.vue?vue&type=template&id=709d899d"
import script from "./marginmaster.vue?vue&type=script&lang=js"
export * from "./marginmaster.vue?vue&type=script&lang=js"
import style0 from "./marginmaster.vue?vue&type=style&index=0&id=709d899d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports